import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mobile-container" }
const _hoisted_2 = { class: "welcome-message" }
const _hoisted_3 = { class: "track-container" }
const _hoisted_4 = {
  key: 0,
  class: "progress"
}
const _hoisted_5 = {
  key: 0,
  class: "manage-tracks list-manage-link"
}
const _hoisted_6 = {
  key: 2,
  class: "foot-container"
}
const _hoisted_7 = { class: "welcome-message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_MobileTrack = _resolveComponent("MobileTrack")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Select = _resolveComponent("Select")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_TrackDisplay = _resolveComponent("TrackDisplay")!
  const _component_TrackEditButton = _resolveComponent("TrackEditButton")!
  const _component_TrackManageModal = _resolveComponent("TrackManageModal")!
  const _component_authenticated_layout = _resolveComponent("authenticated-layout")!

  return (_openBlock(), _createBlock(_component_authenticated_layout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "mobile-track",
          style: _normalizeStyle(_ctx.mobileBackground)
        }, [
          _createElementVNode("h2", _hoisted_2, [
            _createVNode(_component_TranslatedText, {
              class: "styled-content",
              path: "navbar.welcome-back",
              replacements: [
              {
                placeholder: 'value',
                value: _ctx.username,
              },
            ]
            }, null, 8, ["replacements"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_MobileTrack, { hotspots: _ctx.hotspots }, null, 8, ["hotspots"]),
            (!_ctx.editMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_ProgressBar, { value: _ctx.totalProgress }, null, 8, ["value"])
                ]))
              : _createCommentVNode("", true)
          ])
        ], 4)
      ]),
      (_ctx.availableTracks.length > 1 || _ctx.editMode)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "track-select",
            style: _normalizeStyle({ width: _ctx.calcMaxWidth })
          }, [
            _createVNode(_component_Select, {
              value: _ctx.currentTrackSelect,
              items: _ctx.availableTracks,
              required: true,
              searchable: true,
              name: "availableTracks",
              id: "availableTracks",
              onChange: _ctx.handleSelectChange
            }, null, 8, ["value", "items", "onChange"]),
            (_ctx.editMode)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                  (_ctx.userHasPermission('track:manage:*'))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "#",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.showManageModal = true), ["prevent"]))
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "plus" }),
                        _cache[2] || (_cache[2] = _createTextVNode("  ", -1)),
                        _createVNode(_component_TranslatedText, { path: "track.manage.track" })
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 4))
        : _createCommentVNode("", true),
      (_ctx.tracks && _ctx.tracks.length && (_ctx.points?.length || _ctx.editMode))
        ? (_openBlock(), _createBlock(_component_TrackDisplay, {
            key: 1,
            points: _ctx.points,
            hotspots: _ctx.hotspots,
            edit: _ctx.canEdit && _ctx.editMode,
            activePoint: _ctx.activeHotspot,
            curvedLine: _ctx.curvedLine,
            draggedPoint: _ctx.draggedPoint,
            draggedCubic: _ctx.draggedCubic,
            trackIsDirty: _ctx.trackIsDirty,
            onSetPointType: _ctx.setPointType,
            onAddPoint: _ctx.addPoint,
            onSetPointCoords: _ctx.setPointCoords,
            onSetCubicCoords: _ctx.setCubicCoords,
            onRemoveActivePoint: _ctx.removeActivePoint,
            onSetDraggedPoint: _ctx.setDraggedPoint,
            onHotspotClick: _ctx.handleHotspotClick,
            onSetDraggedCubic: _ctx.setDraggedCubic,
            onCancelDragging: _ctx.cancelDragging,
            onDoubleClick: _ctx.handleDoubleClick,
            onTrackSaved: _ctx.handleTrackSaved
          }, null, 8, ["points", "hotspots", "edit", "activePoint", "curvedLine", "draggedPoint", "draggedCubic", "trackIsDirty", "onSetPointType", "onAddPoint", "onSetPointCoords", "onSetCubicCoords", "onRemoveActivePoint", "onSetDraggedPoint", "onHotspotClick", "onSetDraggedCubic", "onCancelDragging", "onDoubleClick", "onTrackSaved"]))
        : _createCommentVNode("", true),
      (!_ctx.editMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("h2", _hoisted_7, [
              _createVNode(_component_TranslatedText, {
                class: "styled-content",
                path: "navbar.welcome-back",
                replacements: [
            {
              placeholder: 'value',
              value: _ctx.username,
            },
          ]
              }, null, 8, ["replacements"])
            ]),
            _createVNode(_component_ProgressBar, {
              value: _ctx.totalProgress,
              size: "lg"
            }, null, 8, ["value"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_TrackEditButton),
      (_ctx.userHasPermission('track:manage:*') && _ctx.showManageModal)
        ? (_openBlock(), _createBlock(_component_TrackManageModal, {
            key: 3,
            show: _ctx.showManageModal,
            tracks: _ctx.tracks,
            onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showManageModal = false)),
            onUpdated: _ctx.handleModalUpdated
          }, null, 8, ["show", "tracks", "onUpdated"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}